import {DescribeBankOfCoresResponse} from "../models/bankOfCoresModel";

export class BankOfCoresUtils {
    static isDeveloperEdition(bankOfCores: DescribeBankOfCoresResponse) {
        return bankOfCores.licenseType.toLowerCase() === "developer";
    }
}
